<template>

    <div class="stats">
        <div class="stat" v-for="stat in stats" :key="stat.label">
            <div v-if="!stat.route" class="stat-body" :class="classes(stat)">
                <span class="label">{{ stat.label }}</span>
                <span class="value">{{ stat.value }}</span>
            </div>
            <router-link v-else :to="stat.route" class="stat-body" :class="classes(stat)">
                <span class="label">{{ stat.label }}</span>
                <span class="value">{{ stat.value }}</span>
            </router-link>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .stats {
        display: grid;
        grid-auto-columns: 1fr;
        grid-auto-flow: column;
        grid-gap: 10px;
    }

    .stat {
        background: #fff;
        line-height: 1.6em;
    }

    .stat-body {
        border: 1px solid $color-rule;
        border-radius: 5px;
        display: block;
        text-decoration: none;
        transition: border-color .3s;
        &.stat-success {
            .value {
                color: $color-success;
            }
        }
        &.stat-danger {
            .value {
                color: $color-danger;
            }
        }
        &.stat-sm {
            padding: 10px 15px;
            .label {
                @include font-medium(12px);
            }
            .value {
                @include font-medium(16px);
            }
        }
        &.stat-lg {
            padding: 15px 20px;
            .label {
                @include font-medium(13px);
            }
            .value {
                @include font-medium(18px);
            }
        }
        .label {
            color: $color-text;
            display: block;
            line-height: normal;
            margin-bottom: 6px;
        }
        .value {
            color: $color-primary;
            display: block;
            line-height: normal;
        }
    }

    a.stat-body {
        cursor: pointer;
        &:hover {
            border-color: $color-text;
        }
    }

</style>

<script>

export default {

    props: {
        stats: {
            type: Array,
            required: true,
        },
        size: {
            type: String,
            default: 'lg',
        },
    },

    methods: {

        classes(stat) {
            return {
                'stat-success': stat.type === 'success',
                'stat-danger': stat.type === 'danger',
                'stat-sm': this.size === 'sm',
                'stat-lg': this.size === 'lg',
            }
        },

    },

}

</script>
